import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Form } from 'react-bootstrap';
import CardHeader from '../../components/common/CardHeader';
import ProductImage from '../../components/common/ProductImage';
import DeleteButton from '../../components/common/DeleteButton';
import ViewButton from '../../components/common/ViewButton';
import EditButton from '../../components/common/EditButton';
import axios from 'axios';
import toast from 'react-hot-toast';
import CardBody from '../../components/common/CardBody';
import LinkButton from '../../components/common/LinkButton';

import Progress from 'react-progress-2';
const HotelList = () => {
      const [loading, setLoading] = useState(false);
      const [hotels, setHotels] = useState([]);
      const [totalHotels, setTotalHotels] = useState(0);
      const [perPages, setPerPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(0);

      const token = JSON.parse(localStorage.getItem('token'));
      const [limit, setLimit] = useState(10);
      const [search, setSearch] = useState('');

      const loadData = async () => {
            setLoading(true);
            axios.get(
                  `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/hotels?limit=${limit}&search=${search}`,
                  {
                        headers: {
                              Authorization: `Bearer ${token}`
                        }
                  }
            )
                  .then((response) => {
                        setHotels(response.data.hotels);
                        setTotalHotels(response.data.totalHotels);
                        setPerPages(response.data.itemsCountPerPage);
                        setCurrentPage(response.data.currentPage);
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      useEffect(() => {
            loadData();
      }, [limit, search]);

      async function getData(pageNumber = 1) {
            window.scrollTo(0, 0);
            setLoading(true);
            Progress.show();
            const url = `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/hotels?page=${pageNumber}&limit=${limit}&search=${search}`;
            await axios(url, {
                  headers: {
                        Authorization: `Bearer ${token}`
                  }
            })
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setHotels(response.data.hotels);
                              setTotalHotels(response.data.totalHotels);
                              setPerPages(response.data.itemsCountPerPage);
                              setCurrentPage(response.data.currentPage);
                        }
                        Progress.hide();
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      }

      const handleStatus = async (category) => {
            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/hotels/${category.slug}/status`,
                        {},
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === 'error') {
                              toast.error(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      const handleDelete = async (blog) => {
            const response = await axios
                  .delete(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/hotels/${blog.slug}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setHotels((hotels) =>
                                    hotels.filter((item) => item.id !== blog.id)
                              );
                              loadData();
                              toast.success(response.data.message);
                              return true;
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            return response;
      };

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader title="Hotel List">
                                          <LinkButton
                                                link="/dashboard/hotels/create"
                                                title="Add New"
                                          />
                                    </CardHeader>
                                    <CardBody
                                          setLimit={setLimit}
                                          perPages={perPages}
                                          totalItems={totalHotels}
                                          currentPage={currentPage}
                                          getData={getData}
                                          setSearch={setSearch}
                                    >
                                          <table className="table table-bordered table-hover">
                                                <thead>
                                                      <tr>
                                                            <th>#</th>
                                                            <th>Title</th>
                                                            <th>Date</th>
                                                            <th width="100px">
                                                                  Status
                                                            </th>
                                                            <th width="120px">
                                                                  Action
                                                            </th>
                                                      </tr>
                                                </thead>
                                                <tbody>
                                                      {!loading ? (
                                                            hotels?.length >
                                                            0 ? (
                                                                  hotels?.map(
                                                                        (
                                                                              blog,
                                                                              index
                                                                        ) => (
                                                                              <>
                                                                                    <tr
                                                                                          key={
                                                                                                index
                                                                                          }
                                                                                    >
                                                                                          <td>
                                                                                                {
                                                                                                      ++index
                                                                                                }
                                                                                          </td>
                                                                                          <td>
                                                                                                <ProductImage
                                                                                                      image={
                                                                                                            blog.image
                                                                                                      }
                                                                                                      title={
                                                                                                            blog.title
                                                                                                      }
                                                                                                      category={`By: ${blog.user_name}`}
                                                                                                />
                                                                                          </td>
                                                                                          <td>
                                                                                                {
                                                                                                      blog.date
                                                                                                }
                                                                                          </td>
                                                                                          <td>
                                                                                                <Form.Check
                                                                                                      type="switch"
                                                                                                      id="custom-switch"
                                                                                                      defaultChecked={
                                                                                                            blog.status ===
                                                                                                            1
                                                                                                                  ? true
                                                                                                                  : false
                                                                                                      }
                                                                                                      onClick={() =>
                                                                                                            handleStatus(
                                                                                                                  blog
                                                                                                            )
                                                                                                      }
                                                                                                />
                                                                                          </td>
                                                                                          <td className="text-center">
                                                                                                <EditButton
                                                                                                      link={`/dashboard/hotels/${blog.slug}/edit`}
                                                                                                />
                                                                                                <ViewButton
                                                                                                      link={`/dashboard/hotels/${blog.slug}/show`}
                                                                                                />
                                                                                                <DeleteButton
                                                                                                      item={
                                                                                                            blog
                                                                                                      }
                                                                                                      loading={
                                                                                                            loading
                                                                                                      }
                                                                                                      setLoading={
                                                                                                            setLoading
                                                                                                      }
                                                                                                      handleDelete={
                                                                                                            handleDelete
                                                                                                      }
                                                                                                />
                                                                                          </td>
                                                                                    </tr>
                                                                              </>
                                                                        )
                                                                  )
                                                            ) : (
                                                                  <tr>
                                                                        <td
                                                                              colSpan={
                                                                                    6
                                                                              }
                                                                              className="text-center"
                                                                        >
                                                                              No
                                                                              Hotel
                                                                              Found
                                                                        </td>
                                                                  </tr>
                                                            )
                                                      ) : (
                                                            <>
                                                                  <tr>
                                                                        <td
                                                                              colSpan={
                                                                                    6
                                                                              }
                                                                              className="text-center"
                                                                        >
                                                                              Loading...
                                                                        </td>
                                                                  </tr>
                                                            </>
                                                      )}
                                                </tbody>
                                          </table>
                                    </CardBody>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default HotelList;
